import React from 'react';

import { ListCard } from './list-card';
import { ListCardContent } from './list-card-content';
import { ListCardMedia } from './list-card-media';
import { ListCardOfferFooter } from './list-card-offer-footer';
import { ListCardProductFooter } from './list-card-product-footer';
import {
  ListCardClickout,
  Props as ListCardClickoutProps,
} from './list-card-clickout';

import { CheapestOffer } from 'src/types';
import { BaseProps } from '../../types';

type Props = BaseProps & {
  showClickout?: boolean;
  cheapestOffer?: CheapestOffer | null;
};

export const ProductListCard: React.FC<Props> = props => {
  const {
    id,
    brand,
    diffPercentage,
    highlightedName,
    imageSize,
    imageSrc,
    name,
    price,
    properties,
    rank,
    rating,
    reviewsCount,
    selectable,
    selected,
    shouldLazyLoadImage,
    type = 'product',
    link,
    onClick,
    className,
    container,
    background,
    onDeselect,
    onSelect,
    buttonAriaLabel,
    ActionArea,
    FooterArea,
    priceInclShipping,
    store,
    priceCount,
    showClickout,
    cheapestOffer,
  } = props;

  const cardProps = {
    id,
    link,
    className,
    container,
    background,
    selected,
    selectable,
    onClick,
    onDeselect,
    onSelect,
    buttonAriaLabel,
    ActionArea,
    FooterArea,
  };

  const contentProps = {
    name,
    highlightedName,
    rank,
    rating,
    reviewsCount,
    diffPercentage,
    price,
    priceInclShipping,
    properties,
    store,
    showClickout,
  };
  const mediaProps = {
    name,
    selectable,
    selected,
    imageSrc,
    imageSize,
    shouldLazyLoadImage,
    brand,
  };
  const offerFooterProps = { store, link, onClick };
  const productFooterProps = { priceCount };

  const clickoutProps: ListCardClickoutProps = {
    store: cheapestOffer?.bestFeaturedOffer?.shop,
    cheapestPrice: {
      inclShipping: cheapestOffer?.bestFeaturedOffer?.priceIncludingShipping,
      exclShipping: cheapestOffer?.bestFeaturedOffer?.priceExcludingShipping,
    },
    priceId: cheapestOffer?.id,
    productId: id,
    price,
    priceCount,
    stockStatus: cheapestOffer?.bestFeaturedOffer?.stockStatus,
    productLink: link,
    storeLink: cheapestOffer?.bestFeaturedOffer?.url,
  };

  // The card shouldn't be clickable for offers
  const isClickable = type === 'product';

  const renderFooter = () =>
    showClickout ? (
      <ListCardClickout {...clickoutProps} />
    ) : (
      <>
        {type === 'offer' && <ListCardOfferFooter {...offerFooterProps} />}
        {type === 'product' && (
          <ListCardProductFooter {...productFooterProps} />
        )}
      </>
    );

  return (
    <ListCard {...cardProps} isClickable={isClickable}>
      <ListCardMedia {...mediaProps} />
      <ListCardContent {...contentProps} showFromPrice={type === 'product'} />
      {renderFooter()}
    </ListCard>
  );
};
